/* eslint-disable @nx/enforce-module-boundaries */
import { Stack,HStack,Box, VStack } from '@mybridge/ui';
import { forwardRef, useEffect } from 'react';
import { AppliedJobsListing } from 'v4/snippets/jobs/applied-listing';
import { JobsListingLayout } from 'v4/snippets/jobs/layout';
import { JobsListingTabs } from 'v4/snippets/jobs/listing-tabs';
import { MyJobsListingTabs } from 'v4/snippets/jobs/my-listing-tabs';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { MyJobsListingLayout } from 'v4/snippets/jobs/my-jobs-layout';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { isMobile } from 'react-device-detect';
import { DashboardMyCircle } from 'v4/snippets/dashboard/circle';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';

export const JobsListingMyAppliedPage = forwardRef(({ ...props }, ref) => {
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { asPath } = useRouter();

  const getUserSlug = () => {
    return userProfileInfo?.slug || userProfileInfo?.username || null;
  };

  const trackJobTrackingPageVisit = () => {
    const userSlug = getUserSlug();
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.AppliedJobs, userSlug, {
      page_path: asPath,
      page_title: 'Applied Jobs',
      device_type: isMobile ? 'mobile' : 'desktop',
      timestamp: new Date().toISOString()
    });
  };

  useEffect(() => {
    if (userProfileInfo) {
      trackJobTrackingPageVisit();
    }
  }, []);

  return ( 
    <AuthenticatedProviders>
      <HStack spacing={2} alignItems="flex-start" flexGrow={1} w={!isMobile?"1335px" : ""}>
      {!isMobile &&
        <HStack pos="sticky" top="64px" h="500px" alignItems="stretch" spacing={0} padding={"0px 0px 0px 23px"}>
        <Stack
          display={['none', 'none', 'flex']}
          pos="sticky"
          top="64px"
          spacing={2}
          minH="100vh"
          borderBottom="1px solid #e0e0e094"
          height={'500px'}
          zIndex="999"
        >
          <VStack
            spacing={2}
            justifyContent="space-between"
            height="100%"
            align="stretch"
            h="calc(100vh - 0px)"
            backgroundColor="rgb(255, 255, 255)"
          >
            <VStack spacing={2} align="stretch" h="100%" flex="1">
              <SiteShortcutLinks />
              <Box
              //  className={styles.hideTitle}
              >
                <DashboardMyCircle h="300px" flex="1" />
              </Box>
            </VStack>
          </VStack>
        </Stack>
      </HStack>
        }
      <JobsListingLayout>
        <Stack spacing={4} p={2}>
          <JobsListingTabs active={1} />
          <MyJobsListingLayout>
            <MyJobsListingTabs active={1} />
            <AppliedJobsListing />
          </MyJobsListingLayout>
        </Stack>
      </JobsListingLayout>
      </HStack>
    </AuthenticatedProviders>
  );
});

export default JobsListingMyAppliedPage;
